function checkIsTagOutOfStock(marker) {
  return ['sold out', 'out of stock'].includes(marker?.toLowerCase());
}

export default checkIsTagOutOfStock;
